// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2Xnbp","header":"ClearentDisclaimer_header__P2KXT","inner":"ClearentDisclaimer_inner__3vt6A"};